import axiosInstace from 'axios';

export const axios = axiosInstace.create({
  baseURL: 'https://sdk-dev.carenow.healthcare',
});
